interface DividerProps {
}

export function Divider({}: DividerProps) {
    return <hr
        className="my-4 h-0.5 opacity-100 dark:opacity-50"/>
}